import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux'
import { required, email, numericality } from 'redux-form-validators'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd';
import {toastr} from 'react-redux-toastr'
import moment from 'moment';
import { CirclePicker } from 'react-color';
import InputField from '../../../../../helpers/Fields/InputField';
import { createPresentation, copyPresentation, getFolderPresentation } from '../../../../actions';
import SelectField from '../../../../../helpers/Fields/SelectField';
import TreeSelectField from '../../../../../helpers/Fields/TreeSelectField';
import CheckboxField from '../../../../../helpers/Fields/CheckboxField';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
  }
  

  submit = async (values)=> {
    try {
      const {formatMessage} = this.context;
      const {handleClose, folder} = this.props;
     
      await this.props.copyPresentation(values);
      toastr.success(formatMessage('msgNotificationTitleCopyPresentation'), formatMessage('msgNotificationCopyPresentation'))
      this.props.getFolderPresentation(folder.id)
 
      handleClose();
    } catch (error) {
    }
    
  }

  render() {
    const {formatMessage} = this.context
    let { handleSubmit, handleClose, initialValues, folders, valuesForm } = this.props;

    let tree = [];

    folders.forEach(folder => {
      if(!folder.parent_id){
        tree.push({
          title: folder.title,
          value: folder.id,
          children: []
        })
      }
    });

    folders.forEach(folder => {
      if(folder.parent_id){
        tree.forEach(item => {
          if(item.value == folder.parent_id){
            item.children.push({
              title: folder.title,
              value: folder.id,
            })
          }
        })
      }
    });


    if(!valuesForm){
      valuesForm = {};
    }
    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='folder_id'
          label={formatMessage('txtCaptionPresentationFolderNameCopy')}
          component={TreeSelectField}
          tree={tree}
          validate={[required()]}
        />

        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancelPresentation')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage('btnModalCopyPresentation')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_presentation_copy',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_presentation')(state),
  folder: state.folders.item,
  folders: state.folders.list,
})

const mapDispatchToProps = {
  createPresentation,
  copyPresentation,
  getFolderPresentation,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/components/PresentationItems/components/CopyModal/FormContent.jsx